interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/**
 * MOCKUP OFICIAL de KETO 4P (los 6 tomos + los 5 bonos). Es el elemento LCP del
 * hero y se reutiliza en la sección de oferta. No aplicar recortes ni textos
 * encima: se muestra siempre completo y con su proporción original.
 */
export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/aiVCitFpgVHqC7NKo8nfLJ/mockup_final_3-4.png'

/** Panes keto artesanales, luz cálida sobre madera oscura. */
export const PANES_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/642513fe-6eb7-4702-8c75-af8f2702c66b.jpg'

/** Pizza keto con queso fundido. */
export const PIZZAS_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/9f52269b-bbd6-49ec-9b75-542a77f6a443.jpg'

/** Pastas keto cremosas. */
export const PASTAS_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/7cdc577f-07ff-4462-8daa-926cbd9a1989.jpg'

/** Postres keto: brownies, cheesecake y torta de chocolate. */
export const POSTRES_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/fae86411-84d4-4af1-a0a7-fc52497abebd.jpg'

/** Mesa abundante con panes, pizza, pastas y postres keto (banda ancha). */
export const FEAST_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/f0453c63-cb1c-420f-ac50-cd6c2b57601d.jpg'

/** La sección de oferta muestra el mockup oficial del producto. */
export const BUNDLE_IMAGE_URL = HERO_IMAGE_URL

const PAGE_TITLE = 'KETO 4P — 500 Recetas Keto: panes, pizzas, pastas y postres'

const META_TAGS: MetaTag[] = [
  {
    name: 'description',
    content:
      'KETO 4P — 500 recetas keto de panes, pizzas, pastas y postres en 6 tomos digitales, sin harinas ni azúcares. Incluye 5 bonos exclusivos y acceso digital inmediato.',
  },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_IMAGE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
